import { COLORS } from "../../../../utils/colors"

export const useScheduleCalendarStyles = () => {
    return {

        calendarContainer: {
          
            overflowY: 'auto',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: '100%',
            backgroundColor: COLORS.WHITE,
            paddingRight: '1rem',
            paddingLeft: '1rem',
            paddingTop: '0px'
          },
          showMoreButton: {
            position: 'absolute',
            bottom: '-1.5rem',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: '12px',
            textTransform: 'none',
            color: COLORS.DARK_GREY,
            marginTop: 'auto',
            padding: '0.2rem 0',
            '&:hover': {
              backgroundColor: '#e2e2e2',
            },
          },
          toolTipContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            // overflow: 'hidden',
          
            // marginBottom: 'auto',
          },
          toolbarContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
           
            width: '100%'
          },
          navigationContainer: {
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: '2.5rem',
          },
          reportsContainer: {
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: '2.5rem',
            padding: '1.38rem'
          },
          navigationTitle: {
            width: "13rem",
            textAlign: "center",
         
          
            marginLeft: '0.1rem',
            marginRight: '0.1rem',
            fontSize: '1.25rem !important',
            color: ' #53617a !important',
            fontWeight: 'normal !important',
            
          },
          eventContainer: {
            display: 'flex',
            backgroundColor: 'transparent !important',
            border: 'none !important',
            padding: '0px !important',
            alignItems: 'center',
          },
          SpotBookingIcon: {
            borderRadius: '1rem',
            width: '12px',
            height: '12px',
            backgroundColor: COLORS.PRIMARY,
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          ProblemSolverIcon: {
            borderRadius: '1rem',
            width: '12px',
            height: '12px',
            backgroundColor: COLORS.PRIMARY,
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          BundleHelpIcon: {
            borderRadius: '1rem',
            width: '12px',
            height: '12px',
            backgroundColor: 'rgb(64, 129, 195)',
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          UnlimitedHelpIcon: {
            borderRadius: '1rem',
            width: '12px',
            height: '12px',
            backgroundColor: '#7c2da3',
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
         
    }
}